import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-48 right-8 z-[55] w-12 h-12 flex items-center justify-center border border-rose-gold/40 bg-ink-900/80 text-rose-gold hover:bg-rose-gold hover:text-ink-900 backdrop-blur-sm transition-colors"
      aria-label="Back to top"
      data-testid="back-to-top"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
